import joint from 'jointjs';

import { createBoxForPanelDragAndDrop } from './create-custom-jointjs-elements';
import { declareCustomJointJSElements } from './declare-custom-jointjs-elements';
import { deserializeGraph } from './deserialize-graph';
import { addLinksLabelFromMetrics, buildMetricsForLinkLabels, linkFactory, removeAllLinksLabels } from './links';
import { paperFactory } from './paper';
import { serializeGraph } from './serialize-graph';
import { initMenus, setBorderColors } from './shared/jointMenu.js';
import { initZoomListeners, removeZoomListeners, scrollToCenter, zoomInOnBoxWithAnimation } from './zoom';

jointDiagram.$inject = ['$timeout', '$uibModal', '$mdDialog', 'AlertingFactory', 'QuickRepliesFactory',
  'MediasFactory', 'StrategiesFactory', '$translate', 'ParametersFactory',
  'ConfirmationFactory', 'UserFactory', 'AngularOptinsService', 'PromoCodeFactory', 'AngularCustomFieldsService', '$q', 'JointjsOptimisationsFactory',
  'AngularCustomEventsService', '$state', 'AngularTranslateService', 'AngularSpinnerService', 'AngularAsyncRequestService', 'AngularMatDialog', 'WhatsappFactory'];
export function jointDiagram($timeout, $uibModal, $mdDialog, AlertingFactory, QuickRepliesFactory,
  MediasFactory, StrategiesFactory, $translate, ParametersFactory,
  ConfirmationFactory, UserFactory, AngularOptinsService, PromoCodeFactory, AngularCustomFieldsService, $q, JointjsOptimisationsFactory,
  AngularCustomEventsService, $state, AngularTranslateService, AngularSpinnerService, AngularAsyncRequestService, AngularMatDialog, WhatsappFactory) {

  let directive = {
    link: link,
    restrict: 'E',
    template: require('./joint-diagram.html'),
    scope: {
      graph: '=',
      graphHasChanged: '=',
      companyId: '<',
      site: '<',
      scenarioId: '<',
      scenarioClicksData: '<',
      isSecondary: '<',
      isSatisfactionSurvey: '<?',
      isCampaignScenario: '<?',
      scenarios: '<'
    },
  };
  return directive;

  function zoomAndBlinkBox(boxId, graph, $myholder, paper) {
    const el = graph.getCell(boxId);
    if (!el) {
      return;
    }
    const elView = el.findView(paper);
    zoomInOnBoxWithAnimation(paper, $myholder, 1.15, elView.$box);
    setTimeout(() => {
      let domElement = elView.$box[0];
      if (domElement) {
        domElement.classList.add("alc-blink");
      }
    }, 1000);
  }

  function link($scope, element, attrs) {

    let strategy = StrategiesFactory.getStrategy($scope.site.type_name);
    let siteTypeConfig = strategy.getQuickRepliesElementsConfig();
    $scope.reorgBtnTooltipText = $translate.instant('parameters/quick_replies/details/reorg_btn_tooltip_text');

    let $myholder = element.find('.joint-diagram-holder');

    // Declare classes for custom jointjs elements
    let services = {
      'joint': joint,
      '$uibModal': $uibModal,
      '$mdDialog': $mdDialog,
      '$translate': $translate,
      '$q': $q,
      '$timeout': $timeout,
      'AlertingFactory': AlertingFactory,
      'QuickRepliesFactory': QuickRepliesFactory,
      'MediasFactory': MediasFactory,
      'WhatsappFactory': WhatsappFactory,
      'ParametersFactory': ParametersFactory,
      'ConfirmationFactory': ConfirmationFactory,
      'UserFactory': UserFactory,
      'AngularOptinsService': AngularOptinsService,
      'PromoCodeFactory': PromoCodeFactory,
      'AngularCustomFieldsService': AngularCustomFieldsService,
      'AngularTranslateService': AngularTranslateService,
      'AngularCustomEventsService': AngularCustomEventsService,
      'JointjsOptimisationsFactory': JointjsOptimisationsFactory,
      'AngularSpinnerService': AngularSpinnerService,
      'AngularAsyncRequestService': AngularAsyncRequestService,
      'AngularMatDialog': AngularMatDialog,
      '$state': $state
    };
    let callbacks = {
      'updateSerializedGraph': updateSerializedGraph,
      'createBox': createBox,
      'serializeGraph': serializeGraph,
      'deserializeGraph': deserializeGraph,
      'linkFactory': linkFactory,
      'resizePaper': () => paper.expandToFitContent(),
      'getScenarioClicksData': () => $scope.scenarioClicksData
    };
    let context = {
      'companyId': $scope.companyId,
      'site': $scope.site,
      'scenarioId': $scope.scenarioId,
      'isSecondary': $scope.isSecondary,
      'isSatisfactionSurvey': $scope.isSatisfactionSurvey,
      'isCampaignScenario': $scope.isCampaignScenario,
      'scenarios': $scope.scenarios
    };

    function resizeHolder() {
      // Element Height = Viewport height - joint-directive's parent offset - desired bottom margin
      const newHolderHeight = angular.element('html').height()
        - element.parent().offset().top
        - 15;
      $myholder.css('height', newHolderHeight);
    }

    resizeHolder();
    const eventNameAndNamespace = 'resize.jointdiagram' + (('' + Math.random()).substring(2));
    angular.element(window).on(eventNameAndNamespace, resizeHolder);
    $scope.$on('$destroy', function () {
      angular.element(window).off(eventNameAndNamespace);
    });

    // Initialize the drawerMenu
    $scope.drawerMenu = initMenus(context).drawerMenu;

    let graph = new joint.dia.Graph();
    let paper = paperFactory($myholder.find('.joint-paper-container'), graph, context, callbacks);

    function updateSerializedGraph(graph) {
      if (!$scope.isLoadingGraph) {
        $scope.$applyAsync(function () {
          $scope.graph = serializeGraph(graph);
          $scope.graphHasChanged = true;
        });
      }
    }

    initZoomListeners(paper, element, $myholder);
    $scope.$on('$destroy', function () {
      removeZoomListeners();
    });

    // DRAG TO SCROLL
    function updateScrollPos(e) {
      angular.element('html').addClass('cursor-grabbing');
      $myholder.scrollLeft(dragStartScrollLeft + (dragStartPosition.x - e.pageX));
      $myholder.scrollTop(dragStartScrollTop + (dragStartPosition.y - e.pageY));
    }

    function dragMousedown(event) {
      dragStartPosition = { x: event.pageX, y: event.pageY };
      dragStartScrollTop = $myholder.scrollTop();
      dragStartScrollLeft = $myholder.scrollLeft();
    }

    let dragStartPosition = null;
    let dragStartScrollTop = null;
    let dragStartScrollLeft = null;
    paper.on('blank:pointerdown', dragMousedown);

    angular.element(window).mouseup(function dragMouseup(e) {
      dragStartPosition = null;
      dragStartScrollTop = null;
      dragStartScrollLeft = null;
      angular.element('html').removeClass('cursor-grabbing');
    });
    angular.element(window).mousemove(function dragMousemove(event) {
      if (dragStartPosition) {
        updateScrollPos(event);
      }
    });


    graph.on('add', function (cell) {
      if (!cell.isLink()) {
        updateSerializedGraph(graph);
      }
    });
    graph.on('remove', function (cell) {
      updateSerializedGraph(graph);
    });

    //make port not interactive after it's connected
    // and change the color of an out port depending on whether it is connected or not
    graph.on('add', function (cell) {
      if (cell.isLink()) {
        let answer = cell.getSourceElement();
        let port = answer.getPorts()[0];
        // port might have been removed,
        // for example if a messenger button changes from postback to web_url
        if (port) {
          answer.portProp(port.id, 'attrs/.port-body/pointer-events', 'none');
          answer.portProp(port.id, 'attrs/circle', { stroke: 'black' });
        }

        cell.on('remove', function (link) {
          let answer = link.getSourceElement();
          let port = answer.getPorts()[0];
          // port might have been removed, 
          // for example if a messenger button changes from postback to web_url
          if (port) {
            answer.portProp(port.id, 'attrs/.port-body/pointer-events', 'auto');
            answer.portProp(port.id, 'attrs/circle', { stroke: 'red' });
          }
        });
      }
    });


    declareCustomJointJSElements(services, callbacks, context, siteTypeConfig);

    /* PANEL */
    setBorderColors($scope.drawerMenu);

    $scope.panelElementMousedown = (evt) => {
      $scope.isDrawerOpen = false;  // close drawer panel that sits above the graph
      angular.element('html').addClass('cursor-grabbing');
      angular.element('body').append('<div id="fly-paper" class="cursor-grabbing" style="position:fixed;z-index:100;opacity:.7;pointer-event:none;"></div>');
      let flyGraph = new joint.dia.Graph();
      let flyPaper = new joint.dia.Paper({
        el: angular.element('#fly-paper'),
        model: flyGraph,
        interactive: false
      });

      let position = { x: 50, y: 50 };
      let flyIds = [];
      for (let x = 0; x < 12; x++) {
        flyIds.push('dummy' + x);
      }
      let boxType = angular.element(evt.target).attr('data-box-type');
      const flyParams = {
        'boxType': boxType,
        'ids': flyIds,
        'position': position,
        'graph': flyGraph,
        'paper': flyPaper,
        'isDummy': true
      };
      let flyShape = createBoxForPanelDragAndDrop(services, context, callbacks, flyParams);

      // // Add 50 because the element bounding box goes into negative x and y. (If flyShape position is 0,0 some of it isn't displayed)
      let offset = {
        x: 50,
        y: 50
      };
      angular.element('#fly-paper').offset({
        left: evt.pageX - offset.x,
        top: evt.pageY - offset.y
      });
      flyPaper.findViewByModel(flyShape).$el.addClass('cursor-grabbing');

      angular.element('body').on('mousemove.fly', function (evt) {
        angular.element('#fly-paper').offset({
          left: evt.pageX - offset.x,
          top: evt.pageY - offset.y
        });
      });
      angular.element('body').on('mouseup.fly', function (e) {
        let x = angular.element('#fly-paper').offset().left + flyShape.position().x;
        let y = angular.element('#fly-paper').offset().top + flyShape.position().y;
        let target = paper.$el.parent().offset();

        // Dropped over paper ?
        if (x > target.left && x < target.left + paper.$el.width() && y > target.top && y < target.top + paper.$el.height()) {
          let scale = joint.V(paper.viewport).scale();
          let holderScrollLeft = $myholder.scrollLeft();
          let holderScrollTop = $myholder.scrollTop();
          let position = {
            x: (x - target.left + holderScrollLeft) / scale.sx,
            y: (y - target.top + holderScrollTop) / scale.sy
          };

          createBox(boxType, position);

        }
        angular.element('body').off('mousemove.fly').off('mouseup.fly');
        angular.element('#fly-paper').remove();
        angular.element('html').removeClass('cursor-grabbing');
        paper.expandToFitContent();
      });

    }


    //Reorg btn
    function reorganizeDiag() {
      const serializedGraph = $scope.graph;
      let visitedBoxes = {};
      let diagLvlMaximums = [];
      function reorgQuestionRecursivly(box, parentBox, lvl) {
        if (!box || !box.id || visitedBoxes[box.id]) {
          return;
        }
        visitedBoxes[box.id] = true;
        const el = graph.getCell(box.id);

        // No position to set for the root el
        if (parentBox && parentBox.id) {
          const parentEl = graph.getCell(parentBox.id);
          const xPos = parentEl.get('position').x + 2 * parentEl.get('size').width;
          // First child has same yPos as parent
          let yPos = parentEl.get('position').y;

          // We check against parent top position because first child in answers order might be unlinked.
          if (diagLvlMaximums.length > lvl && diagLvlMaximums[lvl] > parentEl.get('position').y) {
            // Not first child
            let yMax = Math.max(...diagLvlMaximums.slice(lvl, diagLvlMaximums.length));
            yPos = yMax + 78;
          }
          el.set('position', { x: xPos, y: yPos });
        }

        let children = [];

        let elView = paper.findViewByModel(el);
        let type = el.get('type');
        if (type === 'html.QuestionBox' || type === 'html.RootQuestionBox') {
          elView.resizeQuestionBox();
          children = box.answers; // would be nice to refactor this as box.children but this would mean modifying all scenarios in the db...
        } else if (type === 'html.WaitForMessageBox') {
          elView.resizeQuestionBox();
          children = box.children || [];
        } else {
          if (typeof elView.resizeBox === 'function') {
            elView.resizeBox();
          }
          if (Array.isArray(box.children)) {
            children = box.children;
          }
        }

        let elYMax = el.get('position').y + el.get('size').height;
        diagLvlMaximums[lvl] = elYMax;

        for (const childId of children) {
          let child = serializedGraph.elements[childId];
          if (child && child.destination_id && serializedGraph.elements[child.destination_id]) {
            // Remove link vertices
            let links = graph.getConnectedLinks(graph.getCell(child.id));
            if (links.length > 0) {
              links[0].set('vertices', undefined);
            }
            reorgQuestionRecursivly(serializedGraph.elements[child.destination_id], box, lvl + 1);
          }
        }
      }

      reorgQuestionRecursivly(serializedGraph.elements[serializedGraph.root_id], undefined, 0);
      updateSerializedGraph(graph);
    }
    element.find('.reorganizeDiag').click(reorganizeDiag);

    $scope.isLoadingGraph = true;
    $scope.hideElementsWhileLoading = $scope.graph.allElementsHaveSizeAndPosition;
    ParametersFactory.getTagGroups($scope.companyId).then(function (response) {
      context.tagsGroups = response.data;
      let loggedUser = UserFactory.getLoggedUser();
      context.lang = loggedUser.lang ? loggedUser.lang : 'en';
      context.noteBoxesSet = new Set();
      context.noteLimitation = 30;
      services.AngularOptinsService.getOptins().subscribe({
        next: response => {
          context.optins = response;
          let earlyResizeAndScrollCallback = () => {
            // Let's resize and zoom / scroll ASAP (when the Boxes have been deserialised)
            paper.expandToFitContent();
            scrollToCenter($myholder, graph, paper);
          }
          deserializeGraph(services, joint, $scope.graph, graph, paper, linkFactory, context, earlyResizeAndScrollCallback)
            .then(() => {
              afterDeserialize(earlyResizeAndScrollCallback);
              if ($state.params.zoomToBoxId) {
                setTimeout(() => { zoomAndBlinkBox($state.params.zoomToBoxId, graph, $myholder, paper) }, 1000);
              }
            });
        }
      });

    });

    AngularCustomFieldsService.getFields()
      .toPromise()
      .then(function (response) {
        context.customFields = response;
        context.customFieldsMap = response.reduce((result, customField) => {
          result.set(customField.id, customField);
          return result;
        }, new Map());
      });

    services.AngularCustomEventsService.findAll().toPromise().then(res => {
      context.botEventsMap = new Map();
      context.botEvents = (res.scenarioCustomEvents || []).map(item => {
        const botEvent = { ...item, label: `${item.name} (${services.AngularTranslateService.instant(`parameters/custom-events/type/${item.event_type}`)})` }
        context.botEventsMap.set(item.id, botEvent);
        return botEvent
      })
    });

    function afterDeserialize(earlyResizeAndScrollCallback) {
      $scope.isLoadingGraph = false;
      earlyResizeAndScrollCallback(); // let's zoom again so that links and box items fit
      // Handle adding/removing links labels as the metrics mode is switched on/off on the qr detail page
      $scope.$watch('scenarioClicksData', (scenarioClicksData) => {
        if (scenarioClicksData) {
          addLinksLabelFromMetrics(graph, buildMetricsForLinkLabels(graph, scenarioClicksData.total_clicks));
          element.addClass('read-only-diagram');
          updateBoxesLabelsWithId(true);
        }
        else {
          removeAllLinksLabels(graph);
          element.removeClass('read-only-diagram');
          updateBoxesLabelsWithId(false);
        }
      });
    }

    function updateBoxesLabelsWithId(showIds) {
      for (let el of graph.getCells()) {
        if (el.get('isBoxType')) {
          el.updateLabel(showIds);
        }
      }
    }

    function createBox(boxType, position, linkContext = {}) {

      const nbOfIds = 4; // We need at most 4 ids

      services.QuickRepliesFactory.createUniqueIds($scope.companyId, $scope.site.id, $scope.scenarioId, nbOfIds)
        .then(response => {
          let ids = response.data.map(element => element.id);
          const boxParams = {
            'boxType': boxType,
            'ids': ids,
            'position': position,
            'graph': graph,
            'paper': paper,
            'isDummy': false
          };
          createBoxForPanelDragAndDrop(services, context, callbacks, boxParams);

          if (!angular.equals(linkContext, {})) {
            linkContext.targetId = ids[0];
            connectBox(linkContext);
          }
        }, services.AlertingFactory.httpErrorHandler());
    }


    function connectBox(linkContext) {
      const link = linkFactory(paper);
      link.graph = graph;
      link.set('source', {
        id: linkContext.sourceId,
        port: 'out'
      });
      link.set('target', {
        id: linkContext.targetId,
        port: 'in'
      });
      graph.addCell(link);
    }

  } // function link($scope, element, attrs)

} // export function jointDiagram(...)
